<template>
    <edit-sms
        channel="rcs"
        test-path="senders/rcs/test"
        :sender="sender"
        :senders="senders"
        :raw-editing="rawEditing"
        @saved="$emit('saved', $event)"
        @done="$emit('done')"
    />
</template>

<script>
import EditSms from './sms.vue';

export default {
    name: 'edit-rcs-page',
    components: { EditSms },
    props: {
        sender: {
            type: Object,
            required: true,
        },
        senders: {
            type: Array,
            default: () => [],
        },
        rawEditing: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
